'use strict';
module.exports = require('./html-tags.json');



//////////////////
// WEBPACK FOOTER
// /home/travis/build/OffCourse/offcourse-next/node_modules/html-tags/index.js
// module id = 510
// module chunks = 0